module.exports = __webpack_public_path__ + "static/img/6176_phase_function_Paper_PointsHejduk_Prediction.6ac19c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6176_phase_function_Paper_PointsHejduk_Prediction.png
// module id = a+Tj
// module chunks = 0